import { gql } from '@apollo/client';

export default gql`
mutation CreateSelectedProductQuestion($selectedProductQuestion: SelectedProductQuestionInput!){
  createSelectedProductQuestion(
    input: {
      selectedProductQuestion: $selectedProductQuestion
    }
  ) {
    selectedProductQuestion {
      id
    }
  }
}
`;